// hooks/useCampaignSendsLock.js — U1: يعرض وضع مفتاح الإرسال العام (wa_master_kill_switch)
// بالعربية، ويقفل أزرار الإرسال الجماعي حين يكون الوضع «إيقاف الجماعي» أو «إيقاف كامل».
import { useEffect, useState } from "react";
import { api } from "../lib/api";

export const GLOBAL_SWITCH_STATE_AR = {
  allow: "مسموح",
  kill_campaigns_only: "إيقاف الجماعي",
  kill_all: "إيقاف كامل",
  allow_owner_only: "وضع تجريبي (القائمة البيضاء فقط)",
};

export const CAMPAIGN_SENDS_LOCKED_MSG =
  "🔒 الإرسال الجماعي موقوف من مفتاح الإرسال العام (تشخيصات النظام)";

export function globalSwitchLabel(state) {
  return GLOBAL_SWITCH_STATE_AR[state] || "غير معروف";
}

export function useCampaignSendsLock() {
  // fail-closed: موقوف حتى يكتمل الجلب.
  const [unlocked, setUnlocked] = useState(false);
  const [state, setState] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    Promise.all([
      api.get("/settings/campaign-sends-status").then((r) => !!r.data?.unlocked).catch(() => false),
      api.get("/whatsapp/kill-switch").then((r) => r.data?.state || null).catch(() => null),
    ]).then(([u, s]) => {
      if (!alive) return;
      setUnlocked(u);
      setState(s);
      setLoading(false);
    });
    return () => { alive = false; };
  }, []);

  return { unlocked, locked: !unlocked, loading, state, stateLabel: globalSwitchLabel(state) };
}
